var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('span',{staticClass:"currency-sign"},[_vm._v(_vm._s(_vm.hotel.currencySign))]),_vm._v(" "+_vm._s(_vm.formattedAmount)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }